<template>
    <section class="features-3 py-6">
        <div class="container">
            <div class="row ">
                <div class="col-lg-4 mb-lg-0 mb-4 pb-4">
                    <div class="card-body pb-2 h-50">
                        <h1 class="display-1 font-weight-bold text-center text-black">
                            30+
                        </h1>
                        <h2 class="font-weight-bold text-center text-black mt--2">Strategies</h2>
                        <h5 class=" text-justify ms-lg-9 text-gray">
                            Boost your trading success with our 10+ proven strategies for every market
                        </h5>
                    </div>
                    <div class="mt-4">
                        <div class="card-body pb-3 pt-md-0 pt-xl-4 h-50">
                            <h1 class="display-1 font-weight-bold text-center text-black">
                                5
                            </h1>
                            <h2 class="font-weight-bold text-center text-black mt--2">Integrations</h2>
                            <h5 class=" text-justify ms-lg-9 text-gray">
                                Successfully enabled smooth integrations with multiple platforms, driving consistent
                                trading success.
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-lg-0 mb-4 pb-4">
                    <div class="card-body pb-2 h-50">
                        <h1 class="display-1 font-weight-bold text-center text-black">
                            50+
                        </h1>
                        <h2 class="font-weight-bold text-center text-black mt--2">Users</h2>
                        <h5 class=" text-justify ms-lg-9 text-gray">
                            Successfully supported over 50 traders in achieving their trading goals
                        </h5>
                    </div>
                    <div class="mt-4">
                        <div class="card-body pb-3 pt-md-0 pt-xl-4 h-50">
                            <h1 class="display-1 font-weight-bold text-center text-black">
                                1000
                            </h1>
                            <h2 class="font-weight-bold text-center text-black mt--2">Monthly Trades</h2>
                            <h5 class=" text-justify ms-lg-9 text-gray">
                                With 1,000 successful trades each month, we consistently deliver exceptional performance
                                in the market
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-lg-0 mb-4 pb-4">
                    <div class="card-body pb-2 h-50">
                        <h1 class="display-1 font-weight-bold text-center text-black">
                            40%
                        </h1>
                        <h2 class="font-weight-bold text-center text-black mt--2">Profit</h2>
                        <h5 class=" text-justify ms-lg-9 text-gray">
                            Our trading strategies have resulted in a 40% profit with proven results.
                        </h5>
                    </div>
                    <div class="mt-4">
                        <div class="card-body pb-3 pt-md-0 pt-xl-4 h-50">
                            <h1 class="display-1 font-weight-bold text-center text-black">
                                10ms
                            </h1>
                            <h2 class="font-weight-bold text-center text-black mt--2">Excecution Time</h2>
                            <h5 class=" text-justify ms-lg-9 text-gray">
                                Achieving exceptional trading precision with execution times as low as 10ms.
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>